<template>
	<div class="videoArr">
		<div class="videoOuter" v-show="showId"></div>
		<el-dialog :title="dialogTitle" :close-on-click-modal=false :visible.sync="dialogVisible" width="500px" :close="handleClose" top="8vh">
			<div class="dialogMain">
				<dl>
					<dt><span class="checktip">*</span>视频名称：</dt>
					<dd class="cf">
						<el-input v-model="dialogData.name" class="inputWidth" placeholder="视频名称"></el-input>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">*</span>上传视频：</dt>
						  <!--:http-request="hashMd5"
						  :data="fileData"-->
					<dd>
						<el-upload
						  class="upload-demo"
						  ref="upload"
						  :action="'zcvrVideoApi/video/uploadVideo/'+session"
						  :before-upload="beforeAvatarUpload"
						  :on-remove="handleRemove"
						  :file-list="fileList"
						  :on-success="uploadSuccess"
						  :on-error="uploadError"
						  :on-change="handleChange"
						  :limit="2"
						  :auto-upload="false">
						  <!--<el-button size="small" type="primary">上传视频</el-button>-->
						  <el-button slot="trigger" size="small" type="primary">选取视频</el-button>
  						 <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传视频</el-button>
						  <span slot="tip" class="el-upload__tip tooltip">只能上传MP4文件</span>
						</el-upload>
						<div v-show="dialogData.imgUrl"><img :src="dialogData.imgUrl" class="videoImg" @click="play(dialogData)"/></div>
					</dd>
				</dl>
				<dl>
					<dt><span class="checktip">&emsp;*</span>上下架：</dt>
					<dd class="cf">
						<el-switch
						  v-model="dialogData.status"
						  active-color="#13ce66"
						  inactive-color="#ff4949">
						</el-switch>
					</dd>
				</dl>

				<dl>
					<dt><span class="checktip">&emsp;*</span>图集：</dt>
					<dd>
						<el-autocomplete
								class="inline-input"
								v-model="pictureValue"
								:fetch-suggestions="querySearch"
								placeholder="请输入内容"
								@select="handleSelect"
						></el-autocomplete>
					</dd>

				</dl>
				<dl>
					<dt>&ensp;视频描述：</dt>
					<dd class="cf">
						<el-input type="textarea" v-model="dialogData.description" :rows="4" placeholder="描述" ></el-input>
					</dd>
				</dl>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()":loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<div class="mainBody">
			<div>
				<el-input size="small" v-model="filtrateData.name" placeholder="视频名称" class="inputWidth1"></el-input>
				<el-button type="primary" size="mini" @click="handleSearch()" class="searchBtn">查询</el-button>
			</div>
			<div class="filtrateMain">
				<el-button type="primary" size="mini" @click="handleAdd()">新增</el-button>
				<el-button type="danger" size="mini" @click="handleDelete()">删除</el-button>
			</div>
			<div class="isZero" v-show="tableData.length<=0">暂无视频</div>
			<el-row :gutter="20">
				<el-col :xs="12" :sm="10" :md="8" :lg="6" :xl="4" v-for="(item,index) in tableData" :key="index">
					<div :class="item.status==2?'details translucence':'details'">
						<div class="check">
							<el-checkbox @change="checkFn(item.id, index)" :class="'checked'+index"></el-checkbox>
							<!--<input type="checkbox" name="checkbox" @click="deleteFn(item.id)">-->
						</div>
						<div :class="item.imgUrl!=''?'pic':'picHide'" @click="play(item)">
							<img :src="item.imgUrl" width="100%" height="100%" v-show="item.imgSrc!=''"/>
							<div :class="item.imgUrl!=''?'show':'imgHide'">{{item.name}}</div>
						</div>
						<div class="cf" :class="item.imgUrl!=''?'remark':'remarkHide'">{{item.description}}</div>
						<div class="foot cf">
							<span class="dateTime fl">{{item.createTime}}</span>
							<a href="javascript:void(0)" class="el-icon-edit fr" @click="handleEdit(item)" style="color: #000;text-decoration: none;"></a>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!--分页-->
		<div class="page">
			<el-pagination
					background
					:current-page="tableDataArr.currentPage"
					:page-sizes="[10,20,30,40]"
					:page-size="tableDataArr.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="tableDataArr.totalSize"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange">
			</el-pagination>
		</div>


	</div>


</template>

<script>
	import axios from 'axios'
	import management from './management.vue'
	import navZcy from './nav.vue'
	import videojs from  'video.js/dist/video'
	export default{
		data() {
			return {

				loading: false,
				dialogVisible: false,
				dialogTitle: '',
				dialogData: {},
				checked: {},
				showId: false,
				filtrateData: {},
				tableDataArr: {			//分页
					currentPage: 1,
					pageSize: 10,
					totalSize: 0
				},
				filtrateData: {},
				tableData: [],
				fileList: [],
				session: "",
				fileData:{
					videoMd5: ""
				},
				pictureValue:'',
				pictureData:[],
			}
		},
		methods: {
			play: function(item){


 				$('.el-dialog__wrapper').css('z-index','999')
				$('.v-modal').css('z-index','997')
				var div = '<div class="video" style="width: 990px;margin:0 auto;height: 70%;position: relative;"><video id="my-video" class="video-js vjs-big-play-centered" controls style="width: 100%;height:100%;" poster="'+item.imgUrl+'"><source src="'+item.videoUrl+'" type="video/mp4"><p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that<a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p></video>'
				$('.videoOuter').prepend(div)
				$('.video').append('<a href="javascript:void(0)" class="closeBtn">×</a>')
				var videoId = 'my-video'
				var myPlayer = videojs(videoId)
				let vue = this
				$('.closeBtn').click(function(){
					vue.close()
				})
				this.showId = true
				videojs("my-video", {}, function() {
			       	var myPlayer = this;
		    	});



			},
			close: function(){
				$(".video").remove()
			  	this.showId = false
				var myPlayer = videojs('my-video')
				myPlayer.pause();
			},
			beforeAvatarUpload(file) {
//				console.log(file)
		        const isMP4 = file.type === 'video/mp4';

		        if (!isMP4) {
		          this.$message.error('上传视频只能是 mp4 格式!');
		        }
//		        this.hashMd5(file)
		        return isMP4;
		    },
		    submitUpload(){
//		    	console.log(this.fileList)
		    	$('.el-upload-list').css('height',"29px")
		    	this.$refs.upload.submit();
		    },
		    uploadSuccess(response, file, fileList){
//		    	console.log(response)
				if(response.msg=="ok"){
					this.dialogData.videoUrl = response.data.videoUrl
					this.dialogData.imgUrl = response.data.imgUrl
					this.dialogData.videoMd5 = response.data.videoMd5
					if(this.fileList.length==1){
						this.dialogData.videoSize = this.fileList[0].size
					}
					var videoUrlName = this.dialogData.videoUrl.split("/")
				    this.fileList = [{
				    	name: videoUrlName[videoUrlName.length-1]
				    }]
				}else{
					this.$message({
						type: 'error',
						message: response.msg
					});
					if(response.msg=="该SessionId已经超时"){
			  			this.$message.error("登录超时！请重新登录");
			  			this.$router.push({path: '/',query: ''})
			  		}
				}
		    },
		    uploadError(err, file, fileList){
		    	this.$router.push({path: '/',query: ''})
		    },
		    handleChange(files, fileList){
//		    	console.log(fileList)
		    	this.fileList=[]
		    	this.fileList.push(fileList[fileList.length-1])
		    },
			//图片md5值
//			hashMd5(oFile){
//		    	var vue = this
//			   	var fileReader = new FileReader(),
//		        blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
//		        file = oFile,
//		        chunkSize = 2097152,
//		        // read in chunks of 2MB
//		        chunks = Math.ceil(file.size / chunkSize),
//		        currentChunk = 0,
//		        spark = new SparkMD5();
//			    fileReader.onload = function(e) {
//	//		        console.log("read chunk nr", currentChunk + 1, "of", chunks);
//			        spark.appendBinary(e.target.result); // append binary string
//			        currentChunk++;
//
//			        if (currentChunk < chunks) {
//			            loadNext();
//			        }else {
//			        	vue.fileData.videoMd5 = spark.end()
//			        	console.log(vue.fileData)
////						vue.uploadItem(spark.end(),file)
//			        }
//			    };
//			    function loadNext() {
//			        var start = currentChunk * chunkSize,
//			            end = start + chunkSize >= file.size ? file.size : start + chunkSize;
//
//			        fileReader.readAsBinaryString(blobSlice.call(file, start, end));
//			    };
//			    loadNext();
//			},
			handleRemove(file, fileList){
				$('.el-upload-list').css('height','auto')
				this.dialogData.imgUrl = ""
			},
			//上传图片
//			uploadItem(md5,file){
//				let param = new FormData()  // 创建form对象
//			    param.append('file', file, file.name)
//			    param.append('videoMd5', md5)
//				var header = {
//	                'Content-Type': 'multipart/form-data'
//	            }
//				axios.post("zcvrVideoApi/video/uploadVideo/"+sessionStorage.getItem('sessionId'),param,header).then(
//					(success) => {
//						console.log(success)
//						if(success.data.msg=="ok"){
//							console.log("this.fileList")
//							console.log(this.fileList)
//							this.dialogData.videoUrl = success.data.data.videoUrl
//							this.dialogData.imgUrl = success.data.data.imgUrl
//							this.dialogData.videoMd5 = success.data.data.videoMd5
//							var videoUrlName = this.dialogData.videoUrl.split("/")
//						    this.fileList = [{
//						    	name: videoUrlName[videoUrlName.length-1]
//						    }]
//						}else{
//							this.$message({
//								type: 'error',
//								message: success.data.msg
//							});
//							if(success.data.msg=="该SessionId已经超时"){
//					  			this.$message.error("登录超时！请重新登录");
//					  			this.$router.push({path: '/',query: ''})
//					  		}
//						}
//					}
//				)
//			},
			inquiryVideo: function(){
				var data = {
					name: this.filtrateData.name==undefined?this.filtrateData.name:this.filtrateData.name.trim(),
					currentPage: this.tableDataArr.currentPage,
					pageSize: this.tableDataArr.pageSize
				}
				this.$http.post("zcvrVideoApi/video/inquiryVideo/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
		  			(success)=>{
//		  				console.log(success)
		  				if(success.body.msg!="ok"){
		  					this.tableDataArr = {
								currentPage: 1,
								pageSize: 10,
								totalSize: 0
		  					}
		  					this.tableData = []
							this.$message({
								type: 'error',
								message: success.data.msg
							});
							if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}else {
		  					this.tableDataArr = success.body.data
		  					this.tableData = this.tableDataArr.items
		  				}

		  			},
		  			(error)=>{
		  				console.log("数据连接失败")
		  			}
		  		)
			},
			handleClose: function(done) {
				done();
			},
			handleSearch: function() {
				this.tableDataArr.currentPage = 1
				this.inquiryVideo()
			},
			handleAdd: function() {
				this.loading=false
				this.dialogTitle = "新增视频"
				this.dialogData = {}
				this.fileList = []
				this.dialogVisible = true
			},
			handleEdit: function(item) {
				this.loading=false
				this.dialogTitle = "编辑视频"
				this.dialogData = {
					id: item.id,
					name: item.name,
					videoUrl: item.videoUrl,
					videoMd5: item.videoMd5,
					videoSize: item.videoSize,
					imgUrl: item.imgUrl,
					status: item.status==1?true:false,
					description: item.description,
					imgListId:item.imgListId,
				}
				var  reData = this.getPictureDataById(this.dialogData.imgListId);
				console.log(reData)
				if (reData != null){
					this.pictureValue = reData.value;
				}else {
					this.pictureValue = '';
				}
				var videoUrlName = this.dialogData.videoUrl.split("/")
			    this.fileList = [{
			    	name: videoUrlName[videoUrlName.length-1]
			    }]
				this.dialogVisible = true
			},
			handleConfirm: function(){
				var url = ""
				var videoUrl = this.dialogData.videoUrl
				var imgUrl = this.dialogData.imgUrl
				if(videoUrl){
					if(videoUrl.indexOf("http") != -1){
						videoUrl = videoUrl.split("/")
						videoUrl = videoUrl[videoUrl.length-2]+"/"+videoUrl[videoUrl.length-1]
					}
				}
				if(imgUrl){
					if(imgUrl.indexOf("http") != -1){
						var imgUrl = imgUrl.split("/")
						imgUrl = imgUrl[imgUrl.length-2]+"/"+imgUrl[imgUrl.length-1]
					}
				}
				var data = {
					name: this.dialogData.name==undefined?this.dialogData.name:this.dialogData.name.trim(),
					videoUrl: videoUrl,
					videoMd5: this.dialogData.videoMd5,
					videoSize: this.dialogData.videoSize,
					imgUrl: imgUrl,
					status: this.dialogData.status?1:2,
					description: this.dialogData.description,
					imgListId:this.dialogData.currentPictureData.id,
				}
				if(!this.dialogData.id){
					url = "zcvrVideoApi/video/createVideo/"+sessionStorage.getItem('sessionId')
				}else{
					data.id = this.dialogData.id
					url = "zcvrVideoApi/video/updateVideo/"+sessionStorage.getItem('sessionId')
				}
				console.log(data);
				this.loading=true
				this.$http.post(url,data,{emulateJson:true}).then(
		  			(success)=>{
//		  				console.log(success)
						this.loading=false
		  				if(success.data.msg=="ok"){
		  					this.dialogVisible = false
		  					this.inquiryVideo()
		  				}else {
		  					this.$message({
					          message: success.data.msg,
					          type: 'error'
					        });
			  				if(success.data.msg=="该SessionId已经超时"){
					  			this.$message.error("登录超时！请重新登录");
					  			this.$router.push({path: '/',query: ''})
					  		}
		  				}
		  			},
		  			(error)=>{
						this.loading=false
						this.$message.error("数据连接失败");
		  			}
		  		)
			},
			checkFn: function(id,index){
				var len = $('.checked'+index+'.is-checked').length
				if(len==1){
					this.checked[id] = false
				}else{
					this.checked[id] = true
				}
			},
			handleDelete: function() {
				var ids = []
				var checked = this.checked
				Object.keys(checked).forEach(function(key){
				    if(checked[key] == true){
				     	ids.push(key)
				    }
				});
//				console.log(ids)
				if(ids.length>0){
					this.$confirm('此操作将永久删除该视频, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$http.get("zcvrVideoApi/video/deleteVideo/"+sessionStorage.getItem('sessionId')+"/"+ids,{emulateJson:true}).then(
				  			(success)=>{
//				  				console.log(success)
				  				if(success.body.msg=="ok"){
				  					this.$message({
							          message: '删除成功',
							          type: 'success'
							        });
							        this.checked = {}
				       				$('.el-checkbox__input.is-checked').removeClass('is-checked')
							        this.inquiryVideo()
				  				}else{
				  					this.$message({
							          message: success.data.msg,
							          type: 'error'
							        });
					  				if(success.data.msg=="该SessionId已经超时"){
							  			this.$message.error("登录超时！请重新登录");
							  			this.$router.push({path: '/',query: ''})
							  		}
				  				}
				  			},
				  			(error)=>{
				  				console.log("数据连接失败")
				  			}
				  		)
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				}else{
					this.$message({
						type: 'info',
						message: '请选择删除项'
					});
				}
			},
	        //点击页数
			handleCurrentChange(cur) {
				this.tableDataArr.currentPage = cur
				this.inquiryVideo()
			},
			//点击改变显示条目
			handleSizeChange(size) {
				this.tableDataArr.pageSize = size
				this.inquiryVideo()
			},
			querySearch(queryString, cb) {
				var pictureData = this.pictureData;
				var results = queryString ? pictureData.filter(this.createFilter(queryString)) : pictureData;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return (pictureData) => {
					return (pictureData.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				this.dialogData.currentPictureData = item;
			},
			inquiryImgList: function(){
				var data = {
					status:1,
					activate: 1,
					currentPage: 1,
					type:1,
					pageSize: 10000000
				}
				this.$http.post("zcvrVideoApi/imgList/inquiryImgList/"+sessionStorage.getItem('sessionId'),data,{emulateJson:true}).then(
						(success)=>{
							console.log(success)
							if(success.body.msg!="ok"){
								this.pictureData = []
								this.$message({
									type: 'error',
									message: success.data.msg
								});
								if(success.data.msg=="该SessionId已经超时"){
									this.$message.error("登录超时！请重新登录");
									this.$router.push({path: '/',query: ''})
								}
							}else {
								this.tableDataArr = success.body.data
								if(this.tableDataArr.items){
									for (var i =0;i<this.tableDataArr.items.length;i++){
										var item = this.tableDataArr.items[i];
										var _item ={
											id:item.id,
											value:item.name,
										}
										this.pictureData.push(_item);
									}
								}else{
									this.pictureData = []
								}
								console.log(this.pictureData)
							}

						},
						(error)=>{
							console.log("数据连接失败")
						}
				)
			},
			getPictureDataById(id){
				for (var i = 0;i<this.pictureData.length;i++){
					var item = this.pictureData[i];
					if (item.id == id){
						return item;
					}
				}
			},
		},
		mounted(){
			this.inquiryVideo()
			this.inquiryImgList()
			this.session = sessionStorage.getItem('sessionId')

		},
		components: {
			management,
			navZcy
		}
	}
</script>
<style type="text/css">
	a.closeBtn{
		color: #fff;
		font-size: 42px;
	    position: absolute;
	    top: -8px;
		right: 10px;
	    opacity: .9;
	    text-decoration: none;
	}

</style>
<style scoped>
	/*公用的*/
	.fl{
		float: left;
	}
	.fr{
		float: right;
	}
	.cf{
		overflow: hidden;
	}
	.videoOuter{
		width: 100%;
    	height: 100%;
		position: fixed;
		top:0px;
		padding-top: 10%;
		z-index: 1000;
		background: rgba(0,0,0,0.5);
	}
	.video{
		display: inline-block;
		vertical-align: middle;
		width: 80%;
		height: 70%;
		margin: 0 auto;
	}
	.tooltip{
		padding-left: 10px;
	}
	.videoImg{
		width: 200px;
		height: 150px;
		cursor: pointer;
	}
	.mainBody{
		padding: 20px;
	}
	.filtrateMain{
		padding-top: 10px;
		padding-bottom: 20px;
	}
	.searchBtn{
		margin: 0 10px;
	}
	.inputWidth1{
		width: 150px;
	}
	.details{
		position: relative;
		margin-bottom: 20px;
		border: 1px solid #eee;
   		box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
	}
	.details.translucence{
		opacity: 0.5;
	}
	.isZero{
		text-align: center;
		padding: 50px;
	}
	.check{
		position: absolute;
		top: 0;
		right: 0;
		z-index: 10;
		background: #fff;
		padding: 0 5px;
	}
	.pic,.picHide{
		cursor: pointer;
		width: 100%;
		overflow: hidden;
	}
	.pic{
		position: relative;
		height: 165px;
	}
	.pic .show{
		position: absolute;
		width:100%;
		bottom: 0;
		left: 0;
		padding: 10px 20px;
		background: rgba(0,0,0,0.2);
		color: #fff;
		font-weight: bold;
		line-height: 25px;
		height: 70px;
	}
	.picHide{
		height: 70px;
	}
	.picHide .imgHide{
		width:100%;
		padding: 10px 20px;
		background: #fff;
		color: #2a72c5;
		font-weight: bold;
		line-height: 25px;
		height: 70px;
		border-bottom: 1px solid #eee;
	}
	.remark{
		margin: 10px 15px;
		height: 60px;
	}
	.remarkHide{
		margin: 10px 15px;
		height: 155px;
		overflow-wrap: break-word;
	}
	.foot{
		padding: 10px 15px;
		border-top: 1px solid #eee;
	}
	.dateTime{
	    color: #838383;
	    font-size: 10px;
	    line-height: 20px;
	    margin-bottom: 0px;
	}
	.page{
		text-align: center;
	}

</style>
